export default "__VITE_ASSET__DcwBHO6S__"